




import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { shareUrl } from "@/lib/urlHelpers";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "Share",
  components: { BaseIconButton },
  props: {
    copyText: String,
    notificationText: { type: String, default: $t("Link copied") },
  },
  setup(props, ctx) {
    const { copyText = `${window.location.origin}${ctx.root.$route.path}`, notificationText } = props;
    const click = () => shareUrl(copyText, notificationText);
    return { click };
  },
});
